import { createContext, useContext } from "react";
import { ILLMClassifierConfigurationBuilder } from "../DataClasses/LLMClassifierConfigurationBuilder";
import { LLMClassifierStandardBuilder } from "../DataClasses/LLMClassifierStandardBuilder";
import { LLMClassifierLogicChainBuilder } from "../DataClasses/LLMClassifierLogicChainBuilder";

// Using context here along with hooks for each scenario is the easiest way
// to get the correctly typed builder without prop drilling to hell.

export const LLMConfigurationBuilderContext =
    createContext<ILLMClassifierConfigurationBuilder | null>(null);
export function useStandardConfigurationBuilder() {
    const builder = useContext(LLMConfigurationBuilderContext);
    if (!builder || !(builder instanceof LLMClassifierStandardBuilder))
        throw new Error("Invalid hook usage.");
    return builder;
}
export function useLogicChainConfigurationBuilder() {
    const builder = useContext(LLMConfigurationBuilderContext);
    if (!builder || !(builder instanceof LLMClassifierLogicChainBuilder))
        throw new Error("Invalid hook usage.");
    return builder;
}
